import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { RestService, ApiQueryParams } from '../lib/RestService';
import { setQueryParams } from '../lib/helpers';
import { BitrixFile } from '../lib/BitrixFile';

export class Delivery {
  ID:	string;
  CODE:	string;
  NAME:	string;
  SORT:	number;
  CONFIG:	object;
  ACTIVE:	string;
  LOGOTIP: BitrixFile;
  CURRENCY:	string;
  PARENT_ID: number;
  CLASS_NAME:	string;
  DESCRIPTION: string;
  ALLOW_EDIT_SHIPMENT: string;
  PARENT: object;
}

@Injectable()
export class DeliveryService extends RestService {

  private apiUrl = `${environment.apiUrl}shop/Delivery/`;

  constructor(private http: HttpClient) {
    super();
  }

  public get(params?: ApiQueryParams): Promise<Delivery[] | any> {
    const apiUrl = setQueryParams(this.apiUrl, params);
    return this.http.get<Delivery[]>(apiUrl, {withCredentials: true})
      .toPromise()
      .catch(this.handleError);
  }
}
